module.exports = __webpack_public_path__ + "static/media/happy_easter.9e1dc95a.svg";